import { useEffect, useMemo, useState } from 'react';

import { DEFAULT_LIMIT } from '../DelegateTable/lib/helpers';

export const useDelegationState = (wizardState) => {
  const [isDelegateModalOpen, setIsDelegateModalOpen] = useState(false);
  const [isRemoveConfirmOpen, setIsRemoveConfirmOpen] = useState(false);
  const [selectedStepIds, setSelectedStepIds] = useState([]);
  const [selectedSubstepIds, setSelectedSubstepIds] = useState([]);
  const [isRowClick, setIsRowClick] = useState(false);
  const [rowAssignments, setRowAssignments] = useState(null);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [filters, setFilters] = useState({});

  const [steps, setSteps] = useState([]);

  // Sync steps when wizardState loads or changes
  useEffect(() => {
    if (wizardState?.steps && steps.length === 0) {
      setSteps(
        wizardState.steps.map((step) => ({
          ...step,
          name: step.name,
          checked: false,
          substeps: (step.substeps || []).map((sub) => ({ ...sub, checked: false, name: sub.name }))
        }))
      );
    }
  }, [wizardState?.steps, steps.length]);

  const checkedSteps = useMemo(
    () => steps.filter((step) => step.checked && (step.substeps || []).every((sub) => sub.checked)),
    [steps]
  );

  const checkedSubsteps = useMemo(
    () =>
      steps.flatMap((step) => {
        const substeps = step.substeps || [];
        const allSubstepsChecked = substeps.every((sub) => sub.checked);
        const isStepFullyChecked = step.checked && allSubstepsChecked;

        if (isStepFullyChecked) {
          return [];
        }

        return substeps
          .filter((sub) => sub.checked)
          .map((sub) => ({ ...sub, stepName: step.name }));
      }),
    [steps]
  );

  const clearAllSelections = () => {
    setSteps((prevSteps) =>
      prevSteps.map((step) => ({
        ...step,
        checked: false,
        substeps: step.substeps.map((sub) => ({ ...sub, checked: false }))
      }))
    );
  };

  const selectedItemsCount = checkedSteps.length + checkedSubsteps.length;

  return {
    // Modal state
    isDelegateModalOpen,
    setIsDelegateModalOpen,
    isRemoveConfirmOpen,
    setIsRemoveConfirmOpen,
    isRowClick,
    setIsRowClick,
    rowAssignments,
    setRowAssignments,
    // Selection state
    selectedStepIds,
    setSelectedStepIds,
    selectedSubstepIds,
    setSelectedSubstepIds,
    // Pagination state
    page,
    setPage,
    limit,
    setLimit,
    filters,
    setFilters,
    // Steps state
    steps,
    setSteps,
    checkedSteps,
    checkedSubsteps,
    // Helpers
    clearAllSelections,
    selectedItemsCount
  };
};
